// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_addTab(_tab, _forceAdd) {
  
}

function defaultValue_replaceTab(_tab) {
  
}

function defaultValue_toggleTabCancelCTA(_uId) {
  
}

var defaultValue = {
  addTab: defaultValue_addTab,
  replaceTab: defaultValue_replaceTab,
  user_roles: /* [] */0,
  toggleTabCancelCTA: defaultValue_toggleTabCancelCTA
};

var context = React.createContext(defaultValue);

function useWorkSpace(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useWorkSpace ,
  
}
/* context Not a pure module */
